import { Dashboard } from "./pages/Dashboard/Dashboard";

export const routes = [
    {
        route:"/",
        element:<Dashboard/>
    }
]